import CPEstatus from './CPEstatus'
import CustomTroubleshooting from './CustomTroubleshooting'
import IgmpSnoopStatus from './IgmpSnoopStatus'
import LeaseInfo from './LeaseInfo'
import LinkStatus from './LinkStatus'
import MacAddressTable from './MacAddressTable'
import JsonRender from './JsonRender'
import MethodRunner from './MethodRunner'

module.exports = {
  CPEstatus,
  CustomTroubleshooting,
  IgmpSnoopStatus,
  LeaseInfo,
  LinkStatus,
  MacAddressTable,
  JsonRender,
  MethodRunner
}



// WEBPACK FOOTER //
// ./src/projects/access-gui/components/troubleshooting/index.js